import { render, staticRenderFns } from "./preferences.vue?vue&type=template&id=708b4434&scoped=true&"
import script from "./preferences.vue?vue&type=script&lang=js&"
export * from "./preferences.vue?vue&type=script&lang=js&"
import style0 from "./preferences.vue?vue&type=style&index=0&id=708b4434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b4434",
  null
  
)

export default component.exports